var render, staticRenderFns
import script from "./TameMapLayerCanvas.vue?vue&type=script&lang=js"
export * from "./TameMapLayerCanvas.vue?vue&type=script&lang=js"
import style0 from "./TameMapLayerCanvas.vue?vue&type=style&index=0&id=25a222eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports